__turbopack_context__.v({
  "containsDualList": "header-desktop-menu-module-scss-module__c1jEYG__containsDualList",
  "megaMenuContainer": "header-desktop-menu-module-scss-module__c1jEYG__megaMenuContainer",
  "megaMenuFooter": "header-desktop-menu-module-scss-module__c1jEYG__megaMenuFooter",
  "menu-list-desktop": "header-desktop-menu-module-scss-module__c1jEYG__menu-list-desktop",
  "menuBottomContent": "header-desktop-menu-module-scss-module__c1jEYG__menuBottomContent",
  "menuDesktopBanner": "header-desktop-menu-module-scss-module__c1jEYG__menuDesktopBanner",
  "menuDesktopContent": "header-desktop-menu-module-scss-module__c1jEYG__menuDesktopContent",
  "menuDesktopContentWrapper": "header-desktop-menu-module-scss-module__c1jEYG__menuDesktopContentWrapper",
  "menuDesktopImageContent": "header-desktop-menu-module-scss-module__c1jEYG__menuDesktopImageContent",
  "menuHeading": "header-desktop-menu-module-scss-module__c1jEYG__menuHeading",
});
